import { LandingRouteName } from '@shared/feature/landing/application/routes/landing.route-name';
import type { Router } from 'vue-router';

const infiniteRedirectErrorMessage = 'Infinite redirect in navigation guard';

export function redirectToDefaultLandingOnInfiniteLoopNavigationError(router: Router, error: unknown): void {
  if (!(error instanceof Error) || error.message !== infiniteRedirectErrorMessage) {
    return;
  }

  if (router.currentRoute.value.name === LandingRouteName.DefaultLanding) {
    return;
  }

  router.replace({ name: LandingRouteName.DefaultLanding }).catch(() => undefined);
}
